import React, { FC } from "react";
import { TreatmentsContainerTreatment } from "../ServicesContainer/TreatmentsContainerTreatment.csharp";
import { DoctorsContainerCard } from "./DoctorsContainerCard";
import { TreatmentsContainerDoctor } from "./TreatmentsContainerDoctor.csharp";

interface DoctorsContainerListProps {
  doctors: TreatmentsContainerDoctor[];
}

export const DoctorsContainerList: FC<DoctorsContainerListProps> = ({
  doctors,
}) => {
  return (
    <div className="container-fluid mb-5">
      <div className="offset-lg-up">
            <div className="row">
              <div className="col-lg-15 col-xl-12">
                <div className="row">
                  {doctors.map((doctor) => (
                    <div className="edge-to-edge-sm col-sm-12 col-md-9 d-md-flex" key={doctor.id}>
                      <DoctorsContainerCard {...doctor} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
      </div>
    </div>
  );
};
